import { render, staticRenderFns } from "./AirWallexBtn.vue?vue&type=template&id=0e51f4eb&scoped=true&"
import script from "./AirWallexBtn.vue?vue&type=script&lang=js&"
export * from "./AirWallexBtn.vue?vue&type=script&lang=js&"
import style0 from "./AirWallexBtn.vue?vue&type=style&index=0&id=0e51f4eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e51f4eb",
  null
  
)

export default component.exports